import React, { ButtonHTMLAttributes } from 'react';
import cs from 'classnames';
import s from './Button.module.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    active?: boolean;
    className?: string;
    disabled?: boolean;
    variant?: 'primary' | 'secondary' | 'white' | 'subtle' | 'subtleLight' | 'red';
    size?: 'large' | 'medium' | 'small';
    shape?: 'rectangle' | 'oval';
}

const Button = React.forwardRef(
    (
        {
            active,
            onClick,
            className,
            disabled = false,
            variant = 'primary',
            size = 'large',
            shape = 'rectangle',
            style = {},
            children,
            ...rest
        }: ButtonProps,
        ref: React.ForwardedRef<HTMLButtonElement>,
    ) => {
        const rootClassName = cs(
            s.root,
            s[size],
            {
                [s.disabled]: disabled,
                [s.primary]: variant === 'primary',
                [s.secondary]: variant === 'secondary',
                [s.white]: variant === 'white',
                [s.subtle]: variant === 'subtle',
                [s.subtleLight]: variant === 'subtleLight',
                [s.red]: variant === 'red',
                [s.oval]: shape === 'oval',
            },
            className,
        );

        return (
            <button
                ref={ref}
                aria-pressed={active}
                type="button"
                onClick={onClick}
                className={rootClassName}
                disabled={disabled}
                style={{ ...style }}
                {...rest}
            >
                {children}
            </button>
        );
    },
);

Button.displayName = 'BasicButtonComponent';

export { Button };
